export const EAuthLoginFlowId = {
  SessionAlreadyAvailable: 'session_already_available',
  SecurityCsrfViolation: 'security_csrf_violation',
  SessionAal1Required: 'session_aal1_required',
  SecurityIdentityMismatc: 'security_identity_mismatch',
  BrowserLocationChangeRequired: 'browser_location_change_required',
} as const;

export const KRATOS_ADMIN_HOST = 'http://kratos-dcm-bank1-admin-admin';
export const KETO_READ_HOST = 'http://keto-dcm-bank1-admin-read';
export const KETO_WRITE_HOST = 'http://keto-dcm-bank1-admin-write';
